/**
 * @generated SignedSource<<bf785b14459f5bcbedb582e2e5159df2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueTypeGroupHeader_issueTableGrouping$data = {
  readonly issueTypes: ReadonlyArray<{
    readonly avatar: {
      readonly small: string | null | undefined;
    } | null | undefined;
    readonly name: string;
  }>;
  readonly " $fragmentType": "issueTypeGroupHeader_issueTableGrouping";
};
export type issueTypeGroupHeader_issueTableGrouping$key = {
  readonly " $data"?: issueTypeGroupHeader_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueTypeGroupHeader_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueTypeGroupHeader_issueTableGrouping",
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueTypes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "small"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraJqlIssueTypeFieldValue"
};

(node as any).hash = "838558b93c23fe6d10aa63aa37347e32";

export default node;
